import React, { useEffect, useRef, useMemo } from 'react'
import LoadingSpinner from '../components/loading/loading_spinner'

/**
 * 無限スクロール機能を提供するカスタムフック
 */
export const useInfiniteScroll = (
  loadMore: () => void,
  isLoadingMore: boolean, // 追加ローディング中かどうか
  hasMore: boolean, // 追加読み込み可能かどうか
  options?: {
    threshold?: number
    rootMargin?: string
    className?: string
  }
) => {
  const loadingRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const currentRef = loadingRef.current
    if (!currentRef || isLoadingMore || !hasMore) return

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && !isLoadingMore && hasMore) {
          loadMore()
        }
      },
      {
        threshold: options?.threshold ?? 0.1,
        rootMargin: options?.rootMargin ?? '100px',
      }
    )

    observer.observe(currentRef)
    return () => observer.unobserve(currentRef)
  }, [
    isLoadingMore,
    hasMore,
    loadMore,
    options?.threshold,
    options?.rootMargin,
  ])

  const LoadingElement = useMemo(
    () => (
      <div
        ref={loadingRef}
        className={options?.className ?? 'flex justify-center py-8'}
      >
        {isLoadingMore ? <LoadingSpinner /> : null}
      </div>
    ),
    [isLoadingMore, options?.className]
  )

  return { LoadingElement }
}
